<template>
  <div style="height: 1.02rem">
    <div id="topBar" class="top-bar">
    <!-- <div class="logo"><img :src="info.logo | imageToHttps | imageToWebp($webpSurpport)" alt="" /></div> -->
    <div class="top-search" @click="fnOpenSearch">
      <div>
        <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/search.png" />
        <div class="text">
          <textScroll :dataList="info.words"/>
        </div>
      </div>
      <!-- <i class="icon-sao" @click.stop="goPage('https://uplus.haier.com/uplusapp/scan/homescanpage.html', false, true)"></i> -->
    </div>
    <div class="top-other">
      <div class="cart" @click="customerService" style="margin: 0">
        <img class="service" :src="info.kefu | imageToHttps | imageToWebp($webpSurpport)"/>
        <span class="dot" v-if="hasUnreadMsg"> </span>
      </div>
      <div class="cart" @click="goPage('/cart')">
        <img :src="info.cart | imageToHttps | imageToWebp($webpSurpport)" />
        <span v-if="info.cartnum">{{info.cartnum}}</span>
      </div>
      <div @click="showModal"><img :src="info.more | imageToHttps | imageToWebp($webpSurpport)" class="more" /></div>
    </div>
    <div class="search-bg-mask" id="topBarBg" :style="{'background': `${bg}`,'opacity': bgOpacity, 'background-size': `100% ${coverY}` }"></div>
  </div>

  <!-- <lazy-search hiddenId='homeWarp' @go-back="searchComponentShow=false" @search='searchComponentShow=false' v-if='searchComponentLoad' v-show='searchComponentShow' :show='searchComponentShow' defaultRoute/> -->

  <!-- 更多菜单 -->
  <div class="mask" v-show="isShowModal" @click="isShowModal = false" @touchmove.stop.prevent></div>
  <div v-show="isShowModal" @click="isShowModal = false" class="popup-container" :style="{'top': mask}">
    <div class="text" @click="goPage('/messageCenter')"><i class="icon-message"></i>平台消息</div>
    <div class="text" @click="goPage('/orderlist')"><i class="icon-order"></i>我的订单</div>
    <div class="text" @click="goPage('/myCollection')"><i class="icon-fav"></i>我的收藏</div>
    <div class="text" @click="goPage('/coupon')"><i class="icon-quan"></i>优惠券</div>
    <!-- <div class="text" @click="goPage('https://uplus.haier.com/uplusapp/problemFeedBack/feedback.html',true)"><i class="icon-tucao"></i>我要吐槽</div> -->
  </div>
  </div>
</template>

<script>
const textScroll = () => import(/* webpackChunkName: "searchComponent" */'@/components/textscroll/index.vue')

// const lazySearch = () => import(/* webpackChunkName: "searchComponent" */'@/components/search/index.vue')

export default {
  name: 'searchbar',
  components: {
    // lazySearch,
    textScroll,
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    hasUnreadMsg: {
      type: Boolean,
      default: false
    },
    bgType: {
      type: Number,
      default: () => 2
    },
    bg: {
      type: String,
      default: () => ''
    },
    bgOpacity: {
      type: Number,
      default: 1
    },
    mask: {
      type: String,
      default: ''
    }
  },
  // computed: {
  //   textList() {
  //     return this.info.words
  //   },
  // },
  data() {
    return {
      textTimer: null,
      animate: false,
      isShowModal: false, // 更多菜单
      coverY: '',
      searchComponentLoad: false,
      searchComponentShow: false,
      islogining: false, // 是否正在登录中(未拿到token禁止操作)

    }
  },
  watch: {
    bg() {
      /**
       * 下拉刷新 活动背景改变时 强制更新
       */
      this.$nextTick(() => {
        if (this.bgType === 5) { // 上下渐变
          this.coverY = '2.48rem'
          document.getElementById('topBarBg') && (document.getElementById('topBarBg').style = `padding-top: ${this.top}; opacity: ${this.bgOpacity}; background: ${this.bg}; background-size: 100% ${this.coverY};`)
        } else {
          document.getElementById('topBarBg') && (document.getElementById('topBarBg').style = `padding-top: ${this.top}; opacity: ${this.bgOpacity}; background: ${this.bg}; background-size: 100% auto;`)
        }
      })
    }
  },
  mounted() {
    // this.textStartMove()
  },
  methods: {
    // textStartMove() {
    //   clearInterval(this.textTimer)
    //   this.textTimer = setInterval(this.showMarquee, 2000);
    //   document.getElementById('textSearch').addEventListener('webkitTransitionEnd', () => {
    //     this.textList.push(this.textList[0]);
    //     this.textList.shift();
    //     this.animate = false;
    //   })
    // },
    // showMarquee() {
    //   if (this.textList.length > 1) {
    //     this.animate = true;
    //   }
    // },
    goPage(path, intact) {
      switch (path) {
        case '/messageCenter':
          this.$util.gioTrackWithVariable('mall_index_click_platformMsg')
          break;
        case '/orderlist':
          this.$util.gioTrackWithVariable('mall_index_click_myOrders')
          break;
        case '/myCollection':
          this.$util.gioTrackWithVariable('mall_index_click_myCollections')
          break;
        case '/coupon':
          this.$util.gioTrackWithVariable('MB15591')
          break;
        case '/cart':
          this.$util.gioTrackWithVariable('mall_index_click_cart')
          break;
      }
      if (intact) {
        location.href = path
      } else {
        this.$router.push(path)
      }
    },
    /**
    * @description 客服
    */
    customerService() {
      this.$util.gioTrackWithVariable('mall_index_click_IM')
      if (this.islogining) return
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.$store.dispatch('doLogin').then(res => {
          if (res !== 400) {
            this.islogining = false
          } else {
            this.islogining = false
          }
        }).catch(() => {
          this.islogining = false
        })
      } else {
        this.$router.push('/conversationList')
      }
    },
    showModal () {
      this.isShowModal = !this.isShowModal;
    },
    /**
    * @description 点击搜索
    */
    fnOpenSearch() {
      this.$util.gioTrackWithVariable('mall_index_click_searchBox')
      this.$router.push({
        path: '/goodsSearch',
      })
      // if (!this.searchComponentLoad) {
      //   lazySearch().then(() => {
      //     this.searchComponentLoad = true;
      //     this.searchComponentShow = true;
      //   })
      //   return;
      // }
      // this.searchComponentShow = true;
    },
  }
}
</script>

<style lang="scss" scoped>

.top-bar{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: .16rem .32rem;
  justify-content: space-between;
  align-items: center;
  @include max-width;
  box-sizing: border-box;
  z-index: 10;
  transition: background-color 1s;
  background-size: 100% 2.48rem;
  -webkit-user-select: none;
  // position: relative;
  .search-bg-mask{
    width: 100%;
    height: 100%;
    // background: #ffffff;
    // opacity: 0.7;
    position: absolute;
    transition: background-color 1s;
    z-index: 5;
    left: 0;
    top: 0;
  }
}

.logo{
  display: flex;
  width: .88rem;
  height: .44rem;
  margin-right: .27rem;
  vertical-align: middle;
  img{
    width: .88rem;
    height: .44rem;
  }
}

.top-search{
  width: 4.18rem;
  height: .72rem;
  padding: 0 .2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background: rgba(255,255,255,0.3);
  border-radius: .36rem;
  z-index: 10;
  > div{
    height: .72rem;
    display: flex;
    align-items: center;
  }
  img{
    width: .44rem;
    height: .44rem;
    margin-right: .14rem;
    vertical-align: middle;
  }
  .text{
    height: .52rem;
    overflow: hidden;
    p{
      font-size: .28rem;
      line-height: .56rem;
      color: #999999;
      @include text-overflow(1)
    }
  }
  .icon-sao{
    display: inline-block;
    width: .45rem;
    height: .44rem;
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/sao.png) no-repeat;
    background-size: cover;
  }
}

.marquee_top{
  transition: all .5s linear;
  transform: translateY(-.56rem);
}

.top-other{
  margin-left: .4rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 10;
  .service{
    width: .48rem;
    height: .48rem;
  }
  img{
    -webkit-touch-callout: none;
    // pointer-events: none;
    -webkit-user-select: none;
  }

  .cart{
    position: relative;
    display: inline-block;
    height: .48rem;
    width: .48rem;
    font-size: 0;
    margin: 0 .4rem;
    span{
      position: absolute;
      right: -.15rem;
      top: -.1rem;
      padding: 0 .08rem;
      height: .28rem;
      line-height: .28rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .2rem;
      color: #fff;
      border-radius: .3rem;
      background: #ED2856;
    }
    .dot {
      width: 8px;
      height: 8px;
      padding: 0;
      right: -0.05rem;
      top: -0.05rem;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }

  .more{
    width: .48rem;
  }
}

.popup-container {
  position: fixed;
  top:1.28rem;
  left: 50%;
  width: 2.48rem;
  padding: 0 0.24rem;
  background-color: white;
  border-radius: 4px;
  z-index: 25;
  box-shadow: -.2rem .2rem .4rem rgba(0,0,0,.2);
  box-sizing: border-box;
  transform: translateX(1rem);
  &::before{
    content: '';
    display: inline-block;
    position: absolute;
    top: -.14rem;
    right: .2rem;
    width: 0;
    height: 0;
    border-left: .12rem solid transparent;
    border-right: .12rem solid transparent;
    border-bottom: .16rem solid #fff;
  }
  .text {
    padding: .24rem 0;
    color: #333;
    font-size: 0.28rem;
    border-bottom: 0.1px solid #eee;
    display: flex;
    align-items: center;
    flex: 1;
    p{
      white-space: nowrap;
    }
  }
}

.icon-message{
  @include icon-common();
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAyCAYAAAAayliMAAAAAXNSR0IArs4c6QAABSpJREFUaAXtmF1oXEUUx5PdfO+u2IZgsyqBPIj4FEzWEBM0Igajm+o+LKL1tfSlIgEfVES3oiWIWEEoSBEf+vGSh/jBEhpFg2QTYxLQIkKlSUiNiTVubU0i+dqNv7PcG24vu3fmZrf4cgeG+Thn/v9zzsydOzNlZV7yIuBFwIuAFwEvAl4E/r8IlJeKOh6PVy0sLDyWyWQOl5eXPwBueHd3Nyz4tJcolmj/4vf7v2hqavp2cHBwS2TFpqIdaG1tbcTANzHkCAaGTIPou0592Wg3Ijtoka1SP0/f2zMzM6aOKXZV7tuB7u7umrW1tTcwoh/GOgxepByi/DwQCKRGR0c3rJaI/vr6eif6z9Afo7yH8l/0TwWDwXfs+taxTvV9OdDZ2Rne3NwcwoiHMOAa5YlQKHQGI3acyEwZzlSsrq4eZexbjL2L8ofq6upYKpWSpeYquXYgEom0ZLPZJCyyvi9g+DEMX3PFaijjSBBHPqb5AnnJ5/M9PTU19aMbLFcOSOQ3NjamIGgkv876HXBDVkiX7+hVZCfJyzU1NRE3M+EvBGrv7+joqN3a2rpI//3kkhkvPMvLy2PhcHiTaoxd7BF2qXOLi4tay9EnADppe3tbPtgIuudLFXkrr4EpO1NEuKwyp7qWA0T/bkD6+dj+qK+vP+YEWIxMsIVDuAxOJZyWAywd2S1qQUuMjIysK1H3qWBgJ4RLOHVglA709vZWA/Q8+Sr79Sc6oMXoGBxXhdPgdoRTOrCysvI4CEHykO4+78ioEBocQ8JpcDuOUDrA6MOCwNr8zBGphEILV47bCVrHAdk2yxoaGiacgETGgc7f1tbWKccGu670iUx07DJ728KV47bLrW2lA3xQYSKSHh4eln3aMc3Nzb2C/hh/14/sitInMtGxy+xt4RJO4bbL7G2lAwyQY7HWGQVS2W5lueVKKxl9cnjLK7PqWepySi2JA1UAVViA91vddTOQoPlwOqMaozQMkN8AyUVPBQbp76JjllZ9s88srbIC9Ub6ZRYck84SmoU01N7efocjEsLm5ub3cbiLE+pLdl3pE5no2GX2tpy76DtAVjqgnAFALpOf4JDVTvkVuWDimihTnsqnwP4uF5zU9PR0PvEtfTs7O49KB4H76RZBnoZyBgD50hj3XJ7xt6WL+0Zu/5f7s4pA6QBT/w1TnwYoxrm9UgVYrFz+F/DFwLlRV1f3nQpP6YDxaz/LTBwE+LgKsFg59+bjcB2CS+uKqnRADALwXYqb5BPyCiF9tyN1dXUdgEtuZzcrKysHdDi0HOCy8RcROQm4PJucpnR1FdUxJJFI+LiuXgC7Hv2BiYmJ6zrjtBwQII65H+DE11Sf5WJ/WgfcjU4ymZQAPcmYi319fe/pjnUVSZliovQ9RPdBMMDMvKZLVEhPDnfz8/OnwJR/x2xtbW1kbGzs70L69n5XDshgov8i29xZqru85RwaHx//0w6q2zbel85g/FPM7s9VVVVR8BZ0x4ueKwfY4u7kNe4ShPcy9hI/pRaIXZ1xhLSnpyeQTqf7qcoHGyCPVFRUxCcnJ/+h7irp/In3ADFePmAxXo67R3SNl/8H0W3itaGF8XGMj4Ihz5HXKF+ORqOf8hFn94hcVLRngKXzMEvHPCbcgOMyBvgxSE6NPkvpN9voiKyaUh539y4y9P1K+xyPWB/yiCUPvftO2jPAb30JB+ReIK/RIQx4kJylnqXMGKXZlmiadTkDjZNn0blCTrp9PmSsl7wIeBHwIuBFwItA3gj8B+0XK6KrbCz/AAAAAElFTkSuQmCC) no-repeat;
  background-size: contain;
}

.icon-order{
  @include icon-common();
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAqJJREFUaAXtWb9v00AUvjubEVRBkqqsTeI4UwYGlkIHBlDV/wABEwszQuLXwICE+C9ADF1ZEVCpI50QiRtXYkBIHeIwVSiQxI/3ol5lpY599jkyw51k2bn73vfd+97FUV8ZM8M4YBwwDhgHNBzgWWLbzfZGCNOHGHQFANayxKZhOedHwNi+4Nbrnt/bS8PLdUs+pN3bzdbjMJy+RZyD1/k0fI514nQAwru1SnUyGAZKSShVwG241wCmu+jSmAF7zs6JN57nHeXY5MIQ13XX2Di8wzh7gdW1hbA3s1RiITEttBrO+1a9CW7deZQILGCRNEiLNFXohAqIzvwMh86r4LUwJxqnmilkSgnIL2zRxyZub1JDasZhonNKCUQD/rdnk0DZFbF1N9DpdFZGo9F6Hh7Lsvrdbvc4T6yM0U7gz/HvL0hWl4RZ7uEEfMTTD2PuoZ0A43wHf9xu5toBZx9zxUWCtBPwDvtPkY+uUoZ5C5Vie0RU+wi1687tkMNGhFP5kXP2yfP9HeWAGKB2AiFnr/BLfDmGW2GKbyOo3ARswW5NQFxV2O1ZiMX3z05mm9GuwLd+/ytK0lXKMG+hUmyPiGofIbfR/ADAbkQ45eOIC3ZP9y0jyRbdtRNA4r9x5Pj3sw2AKSx5aCfgHfpbS95jIv3SHUpUL2DRJFCAiVoUpgJa9hUQrFQBaryS1qz9V4BoEoXUkJpJWFpTSoC6xjMi6l0ue5xonGqm6Cl1p2uV1Z/UNUZXrlcvVsbV1dr3IAi0ugnz+yLnqyuXHlBzF9c4NnfvD4aDH/O4+c9K3WkKchvOE2z3EblS1eaFMnwOhRDPev7BS5UYpQoQUfBruIeV+AwMKliJCzhV6P8IZmee811yvud771Q2bzDGAeOAccA4oO3AP20MrPxj7LRFAAAAAElFTkSuQmCC) left center no-repeat;
  background-size: contain;
}

.icon-fav{
  @include icon-common();
  background: url(data:image/png;base64,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) no-repeat;
  background-size: contain;
}

.icon-quan{
  @include icon-common();
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA3tJREFUaAXtWE1oE0EU7uaPCOaguVTbEol68iKmSQjRmxgwCN4ED14UPAg9FVFEzEmsIgoi4kUQKYhHExVEMEIgCSYWhZwEpZjWQwStCeY/9XvTXQ+lszPdbGsPMzA7O/Pe+97f/O2OjKiiIqAioCKgIqAioCLw/yKgyaiORqPjvV5vBrzHUHeSjKZpy2iWqVAfhfX1cdbXaf/ohoxBNGSob9Ags4j3rNfrvZbL5X4SzawIHQiHwxMAnUP1mwHZTYMT36DzULlc/mGG7TIjEg0gN8l4AL5CPZ9MJhcqlQpzvFarafV6XQsGg6zfaDS0ZrOptdtt1u90Oprf79eoJaxut6shk6xS3+fzsfd+v8/o1KKMgec+dB7G+w2wnSNeXmGCPCKNT05OfgfYqMfjGc/n8wtmvHbRYrHYPjj9GXjzyMAeM1yHGZFoZDy1m2U86UokEl+oRZlYafhPoQN80a1B2ZIOGGsMa8DYwbjR2pIOcK1dg2CbA1jsL6iuoWPdQ7S7yQpJO4Dz4IQZKBb7capmPLI0bKM+ndeWKcRABoPB81AodEnWCKt8CNQBnCXvSR4BscWBHVhMF1F7wLyOaRKxapxILh6P74bNb8C3F/rm0B4RyQinEA6SpVKpdAtAd1A1KJgSgVqlt1qtK8AfhfFZt9sdh+6iCEvogAEA4Kf0DvCwMWZ3C+yjhOl0OqdxcDZl8KUdcLlcNIWoCOflCtv6nwiSl6TgyB9ZaWkHsIhPEiiUfJIFt8D3gWRwqWO6ZOSFDqRSKQcW7hkYflkHfCADbJGHYUPXVex4p0m3CEfIkE6nlwD4GJXSexsL660I1Cod2K8xfe5B1zZgzGYymZoIS+gAALYTCIDPQsG0CHBYOna8KYfDcUHHIUdMi4wDDADAj8yQ4OBL0G25SuDb44muy9g4uKqFX2RcyVUEOJhcNWS5i2AwuzCV+iIQmQxs2LbJMw5XCadOE2ZAxgGGhWhI3xB5hsmOYw2wDCATtmRAVq9tfDg0WQYQNFsysEiWRSKRcdssFADh0GTfwsiA8CeCzBR6R/oQjYf4WzAm0D00GT/R9uN74K4OlBUBCuc1GY3/OR/hwGb/2PqKS93BYrH428wJY7VzearVaj0QCMwirbvARE4YX0tcmSEJ85g6z3CdPlUoFH4NiaXEVQRUBFQEVARUBFQENjQCfwE8TlA+F0Ee6wAAAABJRU5ErkJggg==) no-repeat;
  background-size: cover;
}

.icon-tucao{
  @include icon-common();
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACo0lEQVRoBe2YvYsTQRjG82VA7a7yvBPPlDaHhhBiBI+zENFKvSvuD7C2EP8IQdH27GyusbK5zltOTEhICkEEQbA5OTRwton58veGXdhmZzY740ZwFob9eOd9n+d93pmd2c1k3OEUcAo4BZwCTgGnwOIUyMaBrlarq+Px+Ol0Ot2g/3IcH4M+x9ls1svn809ardaRLo42AZ/8R8gv6YLZtJPECUms65Io6EB95ZcIuE/Ah7qAung6uy/YLoLdFmz676h8ciqj2Pxhk0mDvOCJQIIVxpbrqEObAI6zMf+3lQ8TDGFp51ucBMKx/7lrl8CiS+Iq4CpgqIAbQoYCGrtrtxJJESqVyjm2H5fZDkwLhcJnFqcfSWOp/KwnUK/Xzw8Gg5eTyeQewLMhOhqNJuVy+Q33j7rd7rGK0Lw2q3MA1S/0+/0G+6cHqD+AzDvaAde/OW9z/lCr1VbmJanqbzUBiL8A7CJED4vF4hpq36RtsjlbE/LYLw2Hw2cqQvPabCdwFQI9yG81Go2fARkZ/5Df4v4X7Vrw3MbZagIQv067EiYfkJSxTyXKuVzuRvDMxtnqJG42m99VpNrt9jeVPYnNagWSEDD1+S8SmL235VvVVK24/iEs7ZqhrQCvP0+AWVF3Q4Hjcpm7X/BRL44BtiqI8W8V3jqrweRltT0D6GtemfdVoHFsxIn1W0VbAfnA5vW3TsA9gCNL6q+w7y2Qlx9be4IZ+riPzFlbgShP1D7CtiIVYHgt095yL38RvkLgbqfT+RLla/O5tgI6MLYG22zcDukn5A9IqJoWeeFmnABD5jntNLFe0W4xH04kcFqH8UrMcBlD9jGqy0Yu9cMkgU+wPUvbgfx+6sx9wMQJlEqlO71e75Tnef1FkXe4TgGngFNg8Qr8ATAc/NKLg12zAAAAAElFTkSuQmCC) no-repeat;
  background-size: cover;
}

.mask{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 20;
}

</style>
